export default __webpack_public_path__ + "static/media/ic-arrow-down-colored.fa418c35.svg";